<template lang="html">
  <div>
    <div class="login__atmosphere">
      <img :src="require('img/login/loginPassword.png')" />
    </div>
    <div autocomplete="off"
          v-on:keyup.enter="send">
      <h2 class="login-form__title">{{ $t('login.reset') }}</h2>
      <p v-if="validLink && !showSuccess && !showPasswordsNotTheSameError && !showGenericPasswordError" class="login-form__text">
        {{ $t('login.resetText') }}
      </p>
      <p v-if="!validLink" class="login-form__text">
        {{ $t('login.resetFail') }}
      </p>
      <p v-if="showGenericPasswordError && !showSuccess" class="login-form__text">
        {{ $t('login.resetBadPassFirst') + minLength + $t('login.resetBadPassSecond') + minChars + $t('login.resetBadPassThird')}}
      </p>
      <p v-if="showSuccess" class="login-form__text">
        {{ $t('login.resetSuccess') }}
      </p>

      <p4a-input class="login-input"
                  v-if="validLink && !showSuccess"
                  :name="'new'"
                  :type="'password'"
                  :size="'large'"
                  :warning="{visible: showError, showIcon: true, message: 'Verplicht veld'}"
                  :valid="false"
                  :fullWidth="true"
                  :leftIcon="'password'"
                  :placeholder="$t('login.resetNew')"
                  :autofocus="true"
                  v-model="passwordNew" />

      <p4a-input class="login-input"
                  v-if="validLink && !showSuccess"
                  :name="'confirm'"
                  :type="'password'"
                  :size="'large'"
                  :warning="{visible: showError, showIcon: true, message: 'Verplicht veld'}"
                  :valid="false"
                  :fullWidth="true"
                  :leftIcon="'password'"
                  :placeholder="$t('login.resetConfirm')"
                  v-model="passwordConfirm" />

      <p4a-button class="login-button"
                  v-if="validLink && !showSuccess"
                  :showIcon="false"
                  :onlyIconVisible="false"
                  :icon="'user'"
                  :product="'ds'"
                  :size="'large'"
                  :disable="false"
                  :fullWidth="true"
                  :text="$t('login.resetSave')"
                  :borderColor="borderColor"
                  :hoverColor="hoverColor"
                  :backgroundColor="backgroundColor"
                  :hoverFontColor="hoverFontColor"
                  @click="send()">
      </p4a-button>

      <div class="login-form__link">
        <router-link to="/login" class="login-form__link--section">{{ $t('login.back') }}</router-link>
      </div>

    </div>

    <p4a-toast />

  </div>
</template>

<script>
import * as usersAndGroupsApi from 'api/usersAndGroupsApi'
import * as settingsApi from 'api/settingsApi'

export default {
  name: 'PasswordReset',
  data () {
    let self = this
    return {
      passwordSettings: null,
      badpasstext: null,
      minChars: null,
      minLength: null,
      passwordNew: null,
      passwordConfirm: null,
      passwordResetId: self.$route.query.passwordResetId,
      showGenericPasswordError: false,
      showSuccess: false,
      validLink: false,
      showError: false,
      hoverColor: undefined,
      borderColor: undefined,
      backgroundColor: undefined,
      hoverFontColor: undefined
    }
  },
  methods: {
    send (event) {
      let self = this
      if (event) {
        event.preventDefault()
      }
      if (self.passwordNew !== self.passwordConfirm) {
        self.showSuccess = false
        self.showGenericPasswordError = true
        self.showError = true
        self.$p4aToast.show(this.$t('login.reset'), this.$t('login.resetDiffer'), 'error', '3000')
      } else {
        self.showPasswordsNotTheSameError = false
        usersAndGroupsApi.resetpassword({password: self.passwordNew, id: self.passwordResetId}).then(succes => {
          if (succes) {
            self.showSuccess = true
          } else {
            self.showSuccess = false
            settingsApi.getPasswordSettings().then(result => {
              if (result) {
                self.passwordSettings = result
                self.minChars = self.passwordSettings.MinRequiredNonAlphanumericCharacters
                self.minLength = self.passwordSettings.MinRequiredPasswordLength
                self.showGenericPasswordError = true
                self.showError = true
              }
            })
          }
        })
      }
    }
  },
  // beforeCreate () {
  //   let lang = ''
  //   switch (this.$route.query.lang) {
  //     case '0':
  //       lang = 'nl'
  //       break
  //     case '1':
  //       lang = 'en'
  //       break
  //     case '3':
  //       lang = 'fr'
  //       break
  //     case '4':
  //       lang = 'de'
  //       break
  //     default:
  //       lang = 'nl'
  //   }
  //   Vue.config.lang = lang
  // },
  created () {
    let self = this
    usersAndGroupsApi.hasvalidpasswordresetlink(self.passwordResetId).then((result) => {
      if (result && result.ErrorCode !== 1) {
        self.validLink = true
      } else {
        self.validLink = false
      }
    }).catch(() => {
      self.validLink = false
    })

    let dsThemeColor = localStorage.getItem('ds-theme-color')
    if (dsThemeColor != null && dsThemeColor !== 'null') {
      this.borderColor = dsThemeColor
      this.hoverColor = dsThemeColor
    }
    let dsThemeFontColor = localStorage.getItem('ds-theme-font-color')
    if (dsThemeFontColor != null && dsThemeFontColor !== 'null') {
      this.backgroundColor = dsThemeFontColor
      this.hoverFontColor = dsThemeFontColor
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/login/inputs/PasswordReset.vue